// 购物车
const shoppingCar = () => import('@/pages/shoppingCar/car.vue');

export default [
  {
    path: '/shoppingCar',
    name: 'shoppingCar',
    component: shoppingCar,
    meta: {
      title: '购物车',
      requireAuth: true,
    },
  },

];
